import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  appReports
} from 'app/components/global';
import editAssessmentDialog from './assessments/dialog.editAssessmentDialog';
import settingsDialog from './dialog.settingsDialog';
import assessments from './assessments';
import controller from './ecat.controller';


export const routeConfig = {
  template: require('./ecat.html'),
  controller: 'ECATController',
  controllerAs: 'ecatVM',
};

export default angular.module('app.components.advisory.ecat', [
  alerts,
  appReports,
  assessments,
  constants,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editAssessmentDialog,
  settingsDialog,
])
  .controller('ECATController', controller)
  .name;

console.log('app.components.advisory.ecat created');
